import { postQuery } from 'Utils/general/utils';
export async function createOrder(body) {
    return postQuery('/api/shop/orders/create', body);
}
